import React from "react";
import InputRange from "react-input-range";
import { Form,InputGroup } from "react-bootstrap";
import "react-input-range/lib/css/index.css";
import { useDispatch } from "react-redux";
import { CHANGE_ABSOLUTE_SL } from "../../../../actions/create-bot-type";

const AbsoluteSL = (props) => {
  const { value, max, min ,hideLabel,isPremiumBot} = props;
  const formatLabel = (value) => (value == 0 ? "Disable" : `${value}%`);
  const formatDecimal = (value,decimals) => Number(Number(value).toFixed(decimals));
  const dispatch = useDispatch();
  const onChange = (val) => {
    if(val > max)
    return
    dispatch({
      type: CHANGE_ABSOLUTE_SL,
      payload: val,
    });
  };
  return (
    <div>
      {!hideLabel && <div>{(formatLabel && formatLabel(value)) || value}</div>}
      <div>
      <Form.Group>
        <InputRange
          step={0.5}
          minValue={min || 0}
          maxValue={max || 100}
          value={formatDecimal(value,2)}
          onChange={(value) => {
            onChange && onChange(value);
          }}
          formatLabel={() => ""}
        />
        </Form.Group>
        {isPremiumBot && <InputGroup>
          <Form.Control
            as="input"
            type="number"
            value={value==0?'':formatDecimal(value,2)}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            min={0}
          ></Form.Control>
          <InputGroup.Append>
            <InputGroup.Text>%</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>}
      </div>
    </div>
  );
};

export default AbsoluteSL;
